import React, { FC } from 'react';
import MakeDecisionModalMain from './makeDecisionModal';
export interface IMakeDecisionData {
  candidateId?: number;
  name?: string;
  requisitionId?: number | string;
  jobTitle?: string;
  lastUpdatedDate?: string | null;
  activityName?: string | null;
}
export interface IMakeDecisionModalProps {
  id: string;
  data: IMakeDecisionData | null;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MakeDecisionModal: FC<IMakeDecisionModalProps> = ({
  id,
  data,
  open,
  setOpen,
}) => {
  return (
    <>
      {open && (
        <MakeDecisionModalMain
          id={`${id}-main`}
          data={data}
          open={open}
          handleClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default MakeDecisionModal;
